import { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'
import FloatingButtons from '../ui/FloatingButtons'
import CookieConsent from '../ui/CookieConsent'

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingButtons />
      <CookieConsent />
    </div>
  )
}
